export default {"src":"/_next/static/media/enterprise.b48728f6.svg","height":1239,"width":1278,"blurWidth":0,"blurHeight":0};